<div class="topup-pack-cards">
  <p class="expiry-hint" *ngIf="expiryHint">{{ expiryHint }}</p>

  <div class="pack-grid" *ngIf="packs.length > 0">
    <button
      type="button"
      class="pack-card"
      *ngFor="let pack of packs"
      [class.pack-card--selected]="isSelected(pack)"
      [class.pack-card--popular]="isMostPopular(pack)"
      [disabled]="disabled"
      (click)="selectPack(pack)">
      <span class="pack-badge" *ngIf="isMostPopular(pack)">Most popular</span>
      <span class="pack-size">{{ pack.packSize }}</span>
      <span class="pack-size-label">credits</span>
      <span class="pack-total">{{ formatZar(pack.totalAmountCents) }}</span>
      <span class="pack-unit">{{ unitPriceLabel(pack) }}</span>
    </button>
  </div>

  <div class="pack-actions">
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="disabled || !selectedPackSize"
      (click)="onBuy()">
      {{ buyLabel }}
    </button>
    <button
      *ngIf="showSkip"
      mat-stroked-button
      type="button"
      [disabled]="disabled"
      (click)="onSkip()">
      {{ skipLabel }}
    </button>
  </div>
</div>
